module.exports = __webpack_public_path__ + "static/hunt2-26c68735ebcb242d64a500530b74264e.jpg";